import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PaginationRequest } from '@classes/pagination/pagination-request';
import { environment } from '@environments/environment';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import * as moment from 'moment';
import { Pagination } from '@classes/pagination/pagination';
import * as FileSaver from 'file-saver';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LogsService {
  private userLoginsApi: string = environment.apiUrl + '/user-logins';
  userLoginsListChanged = new Subject<any[]>();
  userLogins = [];

  paginationSubject = new BehaviorSubject<Pagination>(null);

  private lastQueryObj: {
    from: null,
    to: null
  };

  constructor(

    private http: HttpClient

  ) { }

  /* ----------------------------------- GET ---------------------------------- */
  getUserLogins(request: PaginationRequest): void {
    let httpParams = new HttpParams();

    if (request.pageSize && request.page) {
      httpParams = httpParams
        .append("pageSize", request.pageSize.toString())
        .append("page", request.query !== this.lastQueryObj ? "1" : request.page.toString());
    }

    if (request.query) {
        const filters = request.query;


        const filtersQuery = [];

        if (filters.from && filters.to) {

            filtersQuery.push(`date>=${moment(filters.from).startOf('day').utc().format().toString()}`);

            filtersQuery.push(`date<=${moment(filters.to).endOf('day').utc().format().toString()}`);

        }

        httpParams = httpParams.append("Filters", filtersQuery.join());

        this.lastQueryObj = request.query;
    }

    if (request.sort) {
      httpParams = httpParams.append("sorts", request.sort);
    }


    this.http.get<any[]>(`${this.userLoginsApi}`, { params: httpParams, observe: 'response' })
    .subscribe((result: HttpResponse<any[]>) => {

      this.userLogins = result.body;
      this.userLoginsListChanged.next([...this.userLogins]);
      const pagination: Pagination = JSON.parse(result.headers.get('X-Pagination'));
      this.paginationSubject.next({ ...pagination });
    });
  }

  exportExcelUserLogins(request: PaginationRequest) {
    let httpParams = new HttpParams();

    if (request.query) {
        const filters = request.query;


        const filtersQuery = [];

        if (filters.from && filters.to) {

            filtersQuery.push(`date>=${moment(filters.from).startOf('day').utc().format().toString()}`);

            filtersQuery.push(`date<=${moment(filters.to).endOf('day').utc().format().toString()}`);

        }

        httpParams = httpParams.append("Filters", filtersQuery.join());
    }


    return this.http.get(`${this.userLoginsApi}/excel`, { params: httpParams, observe: 'response', responseType: 'blob' })
    .pipe(map(res => this.saveFile(res)));

}

private saveFile(res: HttpResponse<Blob>): Blob {
  FileSaver.saveAs(res.body, res.headers.get('filename'));
  return res.body;
}

}
